import {
  signInWithEmailAndPassword,
  setPersistence,
  browserSessionPersistence,
  browserLocalPersistence,
} from 'firebase/auth';
import auth from '../../firebase';
import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import styles from './Auth.module.css';
import Password from './Password';
import SubmitButton from './SubmitButton';

const LogInPage = ({}) => {
  let location = useLocation();
  let searchParams = new URLSearchParams(location.search);
  let emailId = searchParams.get('emailId') || '';
  let redirectTo = searchParams.get('redirectTo') || '';

  const [email, setEmail] = useState(emailId);
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(true);
  const [correctEmail, setCorrectEmail] = useState(true);
  const [validEmail, setValildEmail] = useState(true);
  const [correctPwd, setCorrectPwd] = useState(true);
  const [userDisabled, setUserDisabled] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    await setPersistence(auth, rememberMe ? browserLocalPersistence : browserSessionPersistence);

    await signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        user.getIdTokenResult().then((idTokenResult) => {
          const status = idTokenResult.claims?.subscription_status;
          const hasAccess = status === 'trialing' || status === 'active' || status === 'free';
          if (hasAccess) {
            navigate(`${redirectTo ? '/' + redirectTo : '/tryrnai'}`);
          } else if (!status) {
            navigate('/select-plan?legacy=true');
          } else {
            navigate('/subscription-expired');
          }
        });
      })
      .catch((error) => {
        setSubmitting(false);

        const errorCode = error.code;

        if (errorCode === 'auth/user-not-found') {
          setCorrectEmail(false);
          setCorrectPwd(true);
        } else if (errorCode === 'auth/user-disabled') {
          setUserDisabled(true);
        } else if (errorCode === 'auth/wrong-password') {
          setCorrectPwd(false);
          setCorrectEmail(true);
        }
      });
  };

  const forgotPassword = async (e) => {
    e.preventDefault();
    // setEmail_(email);
    navigate('/reset-password');
  };

  const onChange = (e) => {
    setPassword(e.target.value);
  };

  const validateEmail = (e) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    setValildEmail(e.target.value.length > 0 ? emailRegex.test(e.target.value) : true);
  };

  return (
    <div style={{ width: '320px' }}>
      <h2>Login</h2>
      <form onSubmit={onSubmit} autoComplete="off">
        <p className={styles['input-label']}>Your email</p>
        <div>
          <input
            className={`${styles['input-email']} ${
              !correctEmail || !validEmail ? styles['input-error'] : ''
            }`}
            type="email"
            placeholder="Enter your work email"
            autoComplete="off"
            required
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              const emailCheck = /@.*\.[a-z]{2}/;
              if (emailCheck.test(e.target.value)) {
                validateEmail(e);
              }
            }}
            onBlur={validateEmail}
          />
        </div>
        {!validEmail && <p className={styles.error}>Make sure that email address is correct.</p>}
        {!correctEmail && (
          <p className={styles.error}>
            User not found. If you don’t have an account please sign up instead.
          </p>
        )}
        {userDisabled && (
          <p className={styles.error}>
            Your account is temporarily disabled. Please email admin@researchnetai.com to regain
            access.
          </p>
        )}

        <Password
          password={password}
          onChange={onChange}
          error={!correctPwd}
          placeholder="Enter your password"
        />

        {!correctPwd && (
          <p className={styles.error}>Something went wrong. Check password & try again.</p>
        )}

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            textAlign: 'left',
            fontSize: '12px',
            paddingTop: '10px',
          }}
        >
          <div>
            <input
              checked={rememberMe}
              type="checkbox"
              className={styles['checkbox']}
              onChange={() => setRememberMe((prevValue) => !prevValue)}
            />
            <label className={styles['checkbox-label']}>Remember me</label>
          </div>
          <Link to="#" onClick={forgotPassword} className={styles.forgotPassword}>
            FORGOT PASSWORD
          </Link>
        </div>

        <div style={{ paddingTop: '20px' }}>
          <SubmitButton
            text={'Continue'}
            disabled={submitting || !validEmail || password?.length < 5}
            disabledText={!validEmail || password?.length < 5}
          />
        </div>
      </form>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '2px',
          fontSize: '14px',
        }}
      >
        <p>Don’t have an account?</p>
        <Link to="/signup">Sign Up</Link>
      </div>
    </div>
  );
};

export default LogInPage;
